<template>
    <button class="md-btn-text_common common-show-more" @click="changeStatus">
        <span class="text">{{ showComplete ? '收起' : '展开' }}</span>
        <i :class="[showComplete ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
    </button>
</template>

<script>
export default {
    name: "ShowMore",
    data() {
        return {
            showComplete: false
        }
    },
    methods: {
        changeStatus(obj) {
            this.showComplete = obj.showComplete ? obj.showComplete : !this.showComplete;
            this.$emit('changeShowNum', this.showComplete)
        },
    }
}
</script>

<style scoped>

</style>
